import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllAddOns,
  getSingleAddOnsById,
  createAddOns,
  updateAddOns,
  deleteAddOns,
} from "@/api/new-api/staff-management/menu-manage/essential-menu/add-ons";

// Thunks

export const fetchAllAddOns = createAsyncThunk(
  "addOns/fetchAll",
  async ({ restaurant_id, menu_id }, { rejectWithValue }) => {
    const res = await getAllAddOns(restaurant_id, menu_id);
    if (res.status === "success") return res.data.add_ons;
    return rejectWithValue(res.message);
  }
);

export const fetchSingleAddOn = createAsyncThunk(
  "addOns/fetchOne",
  async (id, { rejectWithValue }) => {
    const res = await getSingleAddOnsById(id);
    if (res.status === "success") return res.data.add_on;
    return rejectWithValue(res.message);
  }
);

export const createNewAddOn = createAsyncThunk(
  "addOns/create",
  async (data, { rejectWithValue }) => {
    const res = await createAddOns(data);
    if (res.status === "success") return res.data.add_on;
    return rejectWithValue(res.message);
  }
);

export const updateExistingAddOn = createAsyncThunk(
  "addOns/update",
  async ({ id, data }, { rejectWithValue }) => {
    const res = await updateAddOns(id, data);
    if (res.status === "success") return res.data.add_on;
    return rejectWithValue(res.message);
  }
);

export const deleteAddOnsById = createAsyncThunk(
  "addOns/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteAddOns(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State

const initialState = {
  addOns: [],
  singleAddOn: null,

  getLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,

  success: null,
  error: null,
  requestStatus: false,
};

// Slice

const addOnSlice = createSlice({
  name: "addOns",
  initialState,
  reducers: {
    clearAddOnMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
    },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchAllAddOns.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllAddOns.fulfilled, (state, action) => {
        state.getLoading = false;
        state.addOns = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchAllAddOns.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Fetch Single
      .addCase(fetchSingleAddOn.pending, (state) => {
        state.getLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchSingleAddOn.fulfilled, (state, action) => {
        state.getLoading = false;
        state.singleAddOn = action.payload;
        state.requestStatus = true;
      })
      .addCase(fetchSingleAddOn.rejected, (state, action) => {
        state.getLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Create
      .addCase(createNewAddOn.pending, (state) => {
        state.createLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(createNewAddOn.fulfilled, (state, action) => {
        state.createLoading = false;
        state.addOns.push(action.payload);
        state.success = "Add-On created successfully!";
        state.requestStatus = true;
      })
      .addCase(createNewAddOn.rejected, (state, action) => {
        state.createLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Update
      .addCase(updateExistingAddOn.pending, (state) => {
        state.updateLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(updateExistingAddOn.fulfilled, (state, action) => {
        state.updateLoading = false;
        state.addOns = state.addOns.map((addOn) =>
          addOn.id === action.payload.id ? action.payload : addOn
        );
        state.success = "Add-On updated successfully!";
        state.requestStatus = true;
      })
      .addCase(updateExistingAddOn.rejected, (state, action) => {
        state.updateLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Delete
      .addCase(deleteAddOnsById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deleteAddOnsById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.addOns = state.addOns.map((item) =>
          item.id === action.payload ? { ...item, status: "archive" } : item
        );
        state.success = "Add Ons deleted successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteAddOnsById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearAddOnMessages } = addOnSlice.actions;
export default addOnSlice.reducer;
